import * as React from "react";

type Props = {
  property: string;
  value: string | number;
};

export const InfoCard = ({ property, value }: Props) => {
  return (
    <div
      className={
        "w-36 dark:bg-slate-900 bg-slate-50 p-2 text-lg font-bold text-black dark:text-white"
      }
    >
      <div className={" "}>{property}</div>
      <div>{value}</div>
    </div>
  );
};
